import { generateRootObjectSchema, generateColorSchema, generateArraySchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ButtonParticleSpec } from "components/cards/particles/YinzCam";
import { PageParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Floating Navigation Menu", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  logoButton: ButtonParticleSpec.generateSchema("Logo Button","Logo Button on the left side", {
      defaultValues: { link: "/home", container: { padding:"12px 8px", background: { visible: true, color: "#FF4800" }}, image: { sizing: 'contain' } }
  }),
  navigationLinks: generateArraySchema("Navigation Links", "The menu's navigation links",
      ButtonParticleSpec.generateSchema("Navigation Link", "Menu navigation link", {
          defaultValues: {
              container: { height: '100%', padding: "0px 1rem" },
              showImage: false,
              text: { size: '1.8rem', weight: '700', wrap: 'nowrap' }
          },
      })
  ),
  activeColor: generateColorSchema("Active Page Button Color", "Color of the button showing the current page", {
      defaultValue: "#CABD98"
  }),
  mobileMenuPage: PageParticleSpec.generateSchema("Mobile Menu Page", "The page to embed in the mobile naviation menu."),
  homeButtonWidthMobile: generateStringSchema("Home Button Mobile Width", "Home button mobile width necessary for Safari browsers", {
      defaultValue: "70px"
  }),
  currentPageButtonColor: generateColorSchema("Current Page Button Text Color", "Color of the text inside the current page button")
}));